import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const components = {
  p: ({ node, ...p }) => <p className="mb-2 last:mb-0 leading-relaxed" {...p} />,
  strong: ({ node, ...p }) => <strong className="font-bold text-kid-navy" {...p} />,
  em: ({ node, ...p }) => <em className="italic" {...p} />,
  ul: ({ node, ...p }) => <ul className="list-disc pl-5 mb-2 space-y-1" {...p} />,
  ol: ({ node, ...p }) => <ol className="list-decimal pl-5 mb-2 space-y-1" {...p} />,
  li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
  h1: ({ node, ...p }) => <h3 className="font-display font-bold text-kid-navy text-base mt-3 mb-1.5" {...p} />,
  h2: ({ node, ...p }) => <h3 className="font-display font-bold text-kid-navy text-base mt-3 mb-1.5" {...p} />,
  h3: ({ node, ...p }) => <h4 className="font-display font-bold text-kid-navy text-sm mt-2.5 mb-1" {...p} />,
  a: ({ node, ...p }) => <a className="text-kid-teal font-semibold underline hover:no-underline" target="_blank" rel="noopener noreferrer" {...p} />,
  blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-kid-teal/40 pl-3 italic text-kid-muted my-2" {...p} />,
  code: ({ node, inline, ...p }) => inline
    ? <code className="bg-kid-navy/5 rounded px-1.5 py-0.5 text-[.85em] font-mono" {...p} />
    : <code className="block bg-kid-navy/5 rounded-lg p-3 text-[.85em] font-mono overflow-x-auto my-2" {...p} />,
  hr: () => <hr className="border-kid-line my-3" />,
  table: ({ node, ...p }) => <div className="overflow-x-auto my-2"><table className="w-full text-left border-collapse" {...p} /></div>,
  th: ({ node, ...p }) => <th className="border-b-2 border-kid-line px-2 py-1.5 font-poppins font-semibold text-kid-navy" {...p} />,
  td: ({ node, ...p }) => <td className="border-b border-kid-line px-2 py-1.5 align-top" {...p} />,
};

export function ChatMarkdown({ children }) {
  return (
    <div className="kid-chat-md text-sm" data-testid="ai-message-markdown">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
